import React, { useState, useEffect } from "react";
import ModulePreviewData from "./ModulePreviewData";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import "./ModuleView.scss";
import checkMark from "../../images/ChecjmarkGreen.svg";
import checkMarkExpired from "../../images/checkmark-nonfilled.svg";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
const ModuleView = ({
  modulePreviewData,
  modulePreviewOpen,
  setModulePreviewOpen,
}) => {
  const getMLRstatusIcon=(mlr)=>{
    if(mlr==="Available for Use"){
      return checkMark;
    }
    else if(mlr==="Expired"){
      return checkMarkExpired;
    }
  }
  function truncateText(text) {
    if (text.length > 12) {
      return text.substring(0, 12) + "...";
    }
    return text;
  }
  
  return (
    <>
      <Dialog
        open={modulePreviewOpen}
        className="module-view-modal "
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        <div className="module-outer-class">
          <div className="module-header-container">
            <div style={{ marginLeft: "0px" }} className="module-name-text">
              Preview : Content Module Submission Document (CMSD)
            </div>
            <div className="module-view-header">
              <div className="module-name-container">
                <div className="module-light-text"> Module Name: </div>
                <Tooltip title={modulePreviewData?.moduleName}>
                <div className="module-name-text">
                  {truncateText(modulePreviewData?.moduleName)}
                </div>
                </Tooltip>
              </div>
              <div className="module-seperator"></div>
              <div className="module-name-container">
                <div className="module-light-text"> Module Id: </div>
                <div className="module-name-text">
                  {modulePreviewData?.moduleDamName}
                </div>
              </div>
              <div className="module-seperator"></div>
              <div className="module-name-container">
                <div className="module-light-text"> MLR Status: </div>
                <img
                  src={getMLRstatusIcon(modulePreviewData?.mlrStatus)}
                  style={{ marginLeft: "4px" }}
                  alt="CheckMark"
                  className="img-fluid greenCheckmark "
                />
                <div className="module-name-text">
                  {modulePreviewData?.mlrStatus}
                </div>
              </div>
            </div>
          </div>
          <div className="module-divider-line"></div>
        </div>
        <ModulePreviewData
          modulePreviewData={modulePreviewData}
          openedFromModal={true}
        />
        <DialogActions className="module-view-footer modalActions templateBtn">
          <div className="clone-text">
            {/* To clone this module <p className="click-here-link">click here</p> */}
          </div>
          <Button
            onClick={() => setModulePreviewOpen(false)}
            type="submit"
            className="temp-btn"
            autoFocus
          >
            {"CLOSE"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ModuleView;
